import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { UserProvider } from "@/contexts/UserContext";
import { ThemeProvider } from "@/contexts/ThemeContext";

import Welcome from "@/pages/Welcome";
import Home from "@/pages/Home";
import ModulePage from "@/pages/Module";

import Search from "@/pages/Search";

function App() {
 return (
 <ThemeProvider>
 <UserProvider>
 <BrowserRouter>
 <Routes>
 <Route path="/" element={<Welcome />} />
 <Route path="/home" element={<Home />} />
 <Route path="/module/:moduleId" element={<ModulePage />} />

 <Route path="/search" element={<Search />} />
 </Routes>
 <Toaster position="top-right" richColors />
 </BrowserRouter>
 </UserProvider>
 </ThemeProvider>
 );
}

export default App;
